import { keepPreviousData, useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { UserType } from "types/UsersTypes";
import { MetaType } from "types/UtilsTypes";

export default function useGetUsers(page: number) {
  return useQuery({
    queryKey: ["users"],
    queryFn: async () => {
      return axiosInstance.get(`/users?page=${page}`).then((res) => res.data);
    },
    placeholderData: keepPreviousData,
    select: (data: { data: UserType[]; meta: MetaType }) => data,
    retry: false,
  });
}
